import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
} from '@angular/core';

import { Subject } from 'rxjs';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { ERoutes } from 'src/app/core/enums/routes.enum';
import { EScrollPrefix } from 'src/app/core/enums/scroll-to.enum';
import { EInfoType } from 'src/app/core/enums/country-info-type.enum';
import { Destination } from 'src/app/core/types/models/destination.model';
import { CountryDetails } from 'src/app/core/types/models/country-details.model';
import { IBreadcrumb } from 'src/app/core/types/interfaces/breadcrumb.interface';
import { CountryResponse } from 'src/app/core/types/models/country-response.model';

import { ScrollToIdService } from 'src/app/core/services/scroll-to-id.service';
import { CountryInfoParseService } from '../services/country-info-parse.service';

import { SearchLinkComponent } from 'src/app/shared/search-link/search-link.component';

@Component({
    template: '',
    standalone: false
})
export abstract class PageInfoComponent implements OnDestroy {
  @Input()
  countryResponse: CountryResponse = new CountryResponse();
  @Input()
  countryDetails: CountryDetails = new CountryDetails();
  @Input() isFetching: boolean = true;
  @Input() defaultLocationName: string = '';
  @Input() breadcrumbs: IBreadcrumb[] = [];

  abstract menuOpened: boolean[];

  protected readonly eSvgIcons = ESvgIcons;
  protected readonly eRoutes = ERoutes;
  protected readonly eInfoType = EInfoType;
  protected readonly destroySubject$: Subject<void> = new Subject<void>();
  protected readonly countryInfoParseService = inject(CountryInfoParseService);

  protected constructor(
    protected cdr: ChangeDetectorRef,
    protected scrollToIdService: ScrollToIdService,
  ) {}

  ngOnDestroy() {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  public openSearchMenu(menuIndex: number): void {
    this.menuOpened[menuIndex] = true;
    this.cdr.markForCheck();
  }

  public closeSearchMenu(
    menuIndex: number,
    searchLinkComponent: SearchLinkComponent,
  ): void {
    this.menuOpened[menuIndex] = false;
    searchLinkComponent.clearInputValue();
  }

  public preventDefault(e: MouseEvent): void {
    e.preventDefault();
  }

  public flyToGalleryItem(item: Destination): void {
    // if (item?.coordinates) {
    //   this.mapCoordinates = item.coordinates;
    // }
  }

  public scrollToAnchor(elementId: number, e?: MouseEvent): void {
    if (e) {
      e.preventDefault();
    }
    this.scrollToIdService.scrollTo(elementId, EScrollPrefix.ELEMENT, 78);
  }
}
